import { Typography, TextButton, ConfirmationModal } from 'seagull';
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { getAccountingDetails } from "../../../integrations/Accounting/accounting.utils";
import { Accounting } from "../../../types/api.model";
import { BulletList, SectionHelper, PointIndication } from "./components";
import styles from "./ImportingInvoicesToQBOModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//TODO - width and height shouldn't be fixed
export function ImportingInvoicesToQBOModal(props) {
  const {
    onClose,
    downloadCsv
  } = props;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    "data-testid": props['data-testid'],
    title: "Importing invoices to QBO",
    onCloseButtonClick: onClose,
    primaryButtonLabel: "Got it",
    onPrimaryButtonClick: onClose,
    width: "590px",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(SectionHelper, {
        className: styles.section,
        children: /*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          children: ["Your invoices CSV file is being downloaded.", ' ', /*#__PURE__*/_jsx(TextButton, {
            skin: "secondary",
            variant: "paragraph2",
            onClick: downloadCsv,
            children: "Click here"
          }), ' ', "if download doesn\u2019t start."]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.section,
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "h6",
          className: styles.step,
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            weight: "normal",
            as: "span",
            children: "Step 1:"
          }), ' ', "Make sure your CSV is ready to upload to QBO"]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.indicatedText,
          children: [/*#__PURE__*/_jsx(PointIndication, {}), /*#__PURE__*/_jsx(Typography, {
            children: "Ensure that the \u201Cdisplay name\u201D fields on QBO and Anchor match. If required, you can modify it in Anchor or in the CSV."
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.section,
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "h6",
          className: styles.step,
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            weight: "normal",
            as: "span",
            children: "Step 2:"
          }), ' ', "Upload your spreadsheet to QBO"]
        }), /*#__PURE__*/_jsxs(BulletList, {
          children: [/*#__PURE__*/_jsxs(Typography, {
            children: ["In QBO, go to", ' ', /*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              as: "span",
              children: "Settings"
            }), ' ', "and select", ' ', /*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              as: "span",
              children: "Import data."
            })]
          }), /*#__PURE__*/_jsxs(Typography, {
            children: ["Select", ' ', /*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              as: "span",
              children: "Invoices."
            })]
          }), /*#__PURE__*/_jsxs(Typography, {
            children: ["Under the", ' ', /*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              as: "span",
              children: "Browse"
            }), ' ', "button, select the checkboxes to add new customers that don\u2019t already exist in", getAccountingDetails(Accounting.QBO).name, "."]
          }), /*#__PURE__*/_jsxs(Typography, {
            children: ["Select", ' ', /*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              as: "span",
              children: "Browse"
            }), ' ', "and select your invoices spreadsheet."]
          }), /*#__PURE__*/_jsx(Typography, {
            children: "Continue with QBO instructions."
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.section,
        children: /*#__PURE__*/_jsxs(Typography, {
          skin: "secondary",
          variant: "paragraph2",
          children: ["Need more help uploading multiple invoices?", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
            openInNewTab: true,
            variant: "paragraph2",
            href: "https://quickbooks.intuit.com/learn-support/en-us/help-article/import-export-data-files/import-multiple-invoices/L7E9Xrd8l_US_en_US",
            children: "click here"
          })]
        })
      })]
    })
  });
}